import { pdfjs } from "react-pdf";

// Единая точка настройки воркера PDF.js для PdfView/DocView/PreviewThumbnails/
// PreloadDocumentPages.
//
// Раньше воркер грузился напрямую с unpkg.com (внешняя зависимость, ломалась
// на киоске без стабильного интернета) простым присваиванием
// `pdfjs.GlobalWorkerOptions.workerSrc = <url>`. Замена на собственный бандл
// (new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url)) убрала
// зависимость от CDN, но вскрыла вторую проблему: раздающий статику сервер
// не сопоставляет расширению .mjs правильный MIME-тип (частый пробел в
// nginx mime.types — запись для .mjs туда добавили далеко не сразу) и отдаёт
// файл как application/octet-stream. Firefox отказывается выполнять такой
// модуль-воркер ("NS_ERROR_CORRUPTED_CONTENT" в консоли), даже если сами
// байты корректны.
//
// Решение — тот же приём, что уже используется в PdfView.jsx/DocView.jsx для
// самих PDF: скачать содержимое через fetch() и завернуть в Blob с ЯВНО
// назначенным типом. Blob URL несёт тип, проставленный здесь в JS, а не
// заголовок Content-Type от сервера — от MIME-маппинга статики больше не
// зависим вообще.
let workerReadyPromise = null;

const WORKER_URL = new URL(
    "pdfjs-dist/build/pdf.worker.min.mjs",
    import.meta.url
).toString();

export function ensurePdfWorker() {
    if (!workerReadyPromise) {
        workerReadyPromise = fetch(WORKER_URL)
            .then((res) => {
                if (!res.ok) {
                    throw new Error(`Не удалось загрузить воркер PDF.js: ${res.status}`);
                }
                return res.blob();
            })
            .then((rawBlob) => {
                const blob = new Blob([rawBlob], { type: "text/javascript" });
                pdfjs.GlobalWorkerOptions.workerSrc = URL.createObjectURL(blob);
            })
            .catch((err) => {
                workerReadyPromise = null; // Allow Retry after a transient startup/network failure.
                // Резерв: если даже сам fetch воркера не удался (сеть и т.п.),
                // пробуем прямой URL — это ровно то поведение, что было бы без
                // этого модуля, хуже не станет.
                console.error("ensurePdfWorker: не удалось подготовить Blob, использую прямой URL", err);
                pdfjs.GlobalWorkerOptions.workerSrc = WORKER_URL;
            });
    }
    return workerReadyPromise;
}
